<template>
  <base-form :title="formTitle"
             :loading="loading"
             @submit="onSubmit"
             class="cms-form">
    <div class="row">
      <div class="col-lg-6 col-12">
        <fg-input :name="$t('cms.form.title')"
                  required
                  :placeholder="$t('cms.form.title')"
                  :label="$t('cms.form.title')"
                  v-model="model.title"
                  v-validate="'required'"
                  :error="getError($t('cms.form.title'))">
        </fg-input>

        <fg-input required
                  :label="$t('cms.form.description')"
                  :error="getError($t('cms.form.description'))">
          <textarea :placeholder="$t('cms.form.description')"
                    rows="3"
                    class="form-control"
                    :name="$t('cms.form.description')"
                    v-validate="'required'"
                    v-model="model.description">
          </textarea>
        </fg-input>

        <div class="d-flex row">
          <div class="col-6">
            <fg-input :label="$t('cms.form.language')">
              <language-select v-model="model.locale"></language-select>
            </fg-input>
          </div>
          <div class="col-6 mt-2">
            <fg-input :label="$t('cms.form.active')">
              <base-switch v-model="model.active">
              </base-switch>
            </fg-input>
          </div>
        </div>

      </div>
      <div class="d-flex col-lg-6 col-12">
        <fg-input :label="$t('generic.image')" class="mr-4">
          <image-upload size-type="upload"
                        class="post-image"
                        @on-change="onImageChange"
                        :name="model.name"
                        :src="model.image">
          </image-upload>
        </fg-input>
        <fg-input :label="$t('generic.thumbnail')">
          <image-upload @on-change="onThumbnailChange"
                        :name="model.name"
                        :src="model.thumbnail">
          </image-upload>
        </fg-input>
      </div>
      <div class="col-12">
        <fg-input :label="$t('cms.form.text')"
                  required
                  :error="getError($t('cms.form.text'))">
          <wysiwyg :name="$t('cms.form.text')"
                   class="form-control"
                   :class="{'has-danger': getError($t('cms.form.text'))}"
                   v-validate="'required'"
                   v-model="model.text">
          </wysiwyg>
        </fg-input>
      </div>
      <div class="col-12">
        <fg-input :label="$t('cms.form.user')"
                  required
                  :error="getError($t('cms.form.user'))">
          <user-autocomplete :placeholder="$t('cms.form.user')"
                             :name="$t('cms.form.user')"
                             v-model="model.user"
                             v-validate="'required'"
                             value-key="user_uuid"
          >
          </user-autocomplete>
        </fg-input>
      </div>
      <div class="col-12">
        <fg-input :label="$t('cms.form.segments')">
          <segment-autocomplete :placeholder="$t('cms.form.segments')"
                                multiple
                                v-model="model.segment_ids">
          </segment-autocomplete>
        </fg-input>
      </div>
      <div class="col-12">
        <fg-input :label="$t('cms.form.job_board')"
                  required
                  :error="getError($t('cms.form.job_board'))">
          <job-board-autocomplete :placeholder="$t('cms.form.job_board')"
                                  :name="$t('cms.form.job_board')"
                                  v-model="model.job_board_id"
                                  v-validate="'required'">
          </job-board-autocomplete>
        </fg-input>
      </div>
    </div>
  </base-form>
</template>
<script>
  import ImageUpload from 'src/components/ImageUpload'
  import LanguageSelect from 'src/components/LanguageSelect'
  import Wysiwyg from 'src/components/Wysiwyg/RedactorWysiwyg'
  import SegmentAutocomplete from 'src/components/Autocomplete/SegmentAutocomplete'
  import JobBoardAutocomplete from 'src/components/Autocomplete/JobBoardAutocomplete'
  import UserAutocomplete from 'src/components/Autocomplete/UserAutocomplete'
  import { Select, Option } from 'element-ui'

  export default {
    name: 'cms-form',
    components: {
      ImageUpload,
      LanguageSelect,
      Wysiwyg,
      SegmentAutocomplete,
      JobBoardAutocomplete,
      UserAutocomplete,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      loading: Boolean,
      post: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        formTitle: this.$t('cms.form.formTitle'),
        model: {
          thumbnail: '',
          image: '',
          job_board_id: null,
          locale: this.$i18n.locale,
          title: '',
          description: '',
          text: '',
          active: true,
          type: 'blog',
          segment_ids: [],
          user_id: ''
        },
      }
    },
    watch: {
      post: {
        immediate: true,
        handler: function(newVal) {
          if(newVal) {
            this.model = {
              ...this.model,
              ...newVal,
              segment_ids: newVal.segments.map(s => s.id)
            }
            if (!this.model.user.user_uuid) {
              this.model.user.user_uuid = this.model.user.uuid
            }
          }
        }
      },
    },
    methods: {
      onImageChange (src) {
        this.model.image = src
      },
      onThumbnailChange (src) {
        this.model.thumbnail = src
      },
      async onSubmit () {
        let valid = this.$validator.validateAll()
        if (valid) {
          const model = {
            ...this.model,
            user_id: this.model.user.user_uuid,
          }
          this.$emit('submit', model)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .cms-form /deep/ .picture-wrapper {
    display: flex;

    .picture-container {
      max-width: 500px;
    }

    .avatar-wrapper .avatar--autosize {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
